import { AllianzCoverStatus } from '@40seas/entities/allianz';
import { EnumColor } from '@40seas/frontend/common/providers';

export const allianzStatusColorMapping = {
    [AllianzCoverStatus.Pending]: 'default',
    [AllianzCoverStatus.NoCover]: 'error',
    [AllianzCoverStatus.Partial]: 'warning',
    [AllianzCoverStatus.Cover]: 'success',
    [AllianzCoverStatus.Failed]: 'error',
    [AllianzCoverStatus.CheckPolicy]: 'error',
    [AllianzCoverStatus.Closed]: 'error',
    [AllianzCoverStatus.Inactive]: 'error',
    [AllianzCoverStatus.Rejected]: 'error',
} as { [key in AllianzCoverStatus]: EnumColor };
